import { FC } from 'react';

import { Container } from '../container/container';
import styles from './style.module.css';
import {
  Title,
  Row,
  Col,
  EnumPagination,
  HorizontalInfoActionCard,
  LoadingSpin,
} from '@plataformaxvia/design-system';
import { Grid } from '@mui/material';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { ISection } from '../../apis/department';
import { DepartmentSectionsFilterContainer } from './department-sections-filter/department-sections-filter.container';

export interface DepartmentSectionsProps {
  title: string;
  sections: ISection[];
  isLoading: boolean;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  onClickInfo: (sectionId: string) => void;
  isMobile: boolean;
}

export const DepartmentSections: FC<DepartmentSectionsProps> = ({
  title,
  sections,
  isLoading,
  currentPage,
  totalPages,
  setCurrentPage,
  onClickInfo,
  isMobile,
}) => {
  return (
    <div className={styles.topServicesWrap}>
      <Container>
        <div className={styles.topServicesBase}>
          <div
            className={`${styles.sideFilterBase} ${styles.filterContent} filter-content xvia-catalog-search-input__input-list`}
          >
            <DepartmentSectionsFilterContainer />
          </div>
          <div className={styles.servicesBase}>
            {isMobile && (
              <div className={styles.servicesTitleBase}>
                <Row justifyContent="space-between" style={{ width: '100%' }}>
                  <Col base={12}>
                    <Title title={title} as="h2" />
                  </Col>
                </Row>
              </div>
            )}
            {isLoading ? (
              <LoadingSpin />
            ) : (
              <Grid
                className={styles.styledGridServiceCard}
                container
                spacing={3}
              >
                {sections.length > 0 &&
                  sections.map((section) => (
                    <Grid item xs={12} sm={6} key={section.id}>
                      <HorizontalInfoActionCard
                        title={section.name || 'Sem nome'}
                        onInfoClick={() => onClickInfo(section.id)}
                        subtitle={section.departmentSectionType?.title}
                      />
                    </Grid>
                  ))}
                {sections.length === 0 && (
                  <div className={styles.emptyFilter}>
                    <FilterAltOffIcon />
                    Nenhum resultado encontrado para os filtros selecionados.
                    Tente ajustar os critérios de busca.
                  </div>
                )}
              </Grid>
            )}
            {totalPages > 1 && (
              <Grid sx={{ display: 'flex', justifyContent: 'center' }}>
                <EnumPagination
                  currentPage={currentPage}
                  onPageChange={setCurrentPage}
                  setCurrentPage={setCurrentPage}
                  totalPages={totalPages}
                />
              </Grid>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};
